import PropTypes from "prop-types"
import React from "react"

const SaleCustomer = ({ customerName, customerHref, boatName }) => {
  const renderCustomerName = () => {
    if (customerHref) {
      return (
        <a href={customerHref} className="text-blue-600 hover:underline">
          {customerName}
        </a>
      )
    }
    return <span>{customerName}</span>
  }

  return (
    <div className="flex flex-col">
      <span className="text-xs font-semibold uppercase text-gray-700">
        Customer
      </span>
      {customerName ? renderCustomerName() : <span>Guest</span>}
      {boatName && (
        <span className="text-xs text-gray-600">Boat: {boatName}</span>
      )}
    </div>
  )
}

SaleCustomer.propTypes = {
  customerName: PropTypes.string,
  boatName: PropTypes.string,
  customerHref: PropTypes.string,
}

export default SaleCustomer
